import react, { useEffect } from 'react';
import { Box, Step, StepLabel, Stepper, Typography } from '@mui/material';
import { useWizardStepperContext } from '../../../../contexts/useWizardStepper.context';


interface IProps {

}
/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Dec/01/2024
 */
export default function WizardStepperComponent({

}: IProps) {

    // TODO: based on steps valid state make the 
    // circle: red (isInvalid) / green (isValid) / blue (ifActive)
    // text: error / default

    const { steps, activeStepIndex, isStepOptional, isStepSkipped, } = useWizardStepperContext();

    return (<Box sx={{ width: '100%', px: 2, py: 1 }}>
        <Stepper activeStep={activeStepIndex}>
            {steps.map((label, index) => {
                const stepProps: { completed?: boolean } = {};
                const labelProps: {
                    optional?: React.ReactNode;
                } = {};
                if (isStepOptional(index)) {
                    labelProps.optional = (
                        <Typography variant="caption"></Typography>
                    );
                }
                if (isStepSkipped(index)) {
                    stepProps.completed = false;
                }

                // ---
                return (
                    <Step key={label} {...stepProps}>
                        <StepLabel {...labelProps}
                            sx={(theme) => ({
                                '& .MuiStepIcon-root': {
                                    color: index < activeStepIndex
                                        ? theme.palette.success.main // Completed step color
                                        : index === activeStepIndex
                                            ? theme.palette.primary.main // Active step color
                                            : theme.palette.grey[500], // Default color
                                },
                                '& .MuiStepIcon-text': {
                                    fill: index < activeStepIndex
                                        ? theme.palette.common.white // Completed step text color
                                        : index === activeStepIndex
                                            ? theme.palette.common.white
                                            : theme.palette.common.white
                                },
                            })}
                        >{label}</StepLabel>
                    </Step>
                );
            })}
        </Stepper>

    </Box >)
}